import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-mural-digital',
    templateUrl: './mural-digital.component.html',
    styleUrls: ['./mural-digital.component.scss'],
    standalone: false
})
export class MuralDigitalComponent implements OnInit, AfterViewInit {
  @ViewChild('videoPlayer', { static: false }) videoPlayer!: ElementRef<HTMLVideoElement>;

  videoSrc = './assets/videos/mural-digital-video-1.mp4';

  constructor() { }

  ngOnInit(): void {
    // this.carregarVideo();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.esconderVLibras(), 0);
  }

  // todo vai ser utilizado quando for dinamizar a página;
  carregarVideo(): void {
    const urlDaAPI = `${environment.apiUrlFile}core-file-service/v1/external/arquivo/display`;
    const videoPlayer = document.getElementById('videoPlayer') as HTMLVideoElement;
    fetch(`${urlDaAPI}?hash=300c3ac1-0ccb-45a2-a15f-0cf678d8a51c`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro na requisição à API');
        }
        return response.blob();
      })
      .then(videoBlob => {
        this.esconderVLibras();

        const videoURL = URL.createObjectURL(videoBlob);

        videoPlayer.src = videoURL;
        videoPlayer.autoplay = true;
      })
      .catch(error => {
        console.error('Erro ao carregar o vídeo:', error);
      });
  }

  esconderVLibras(): void {
    const vLibras = document.getElementById('vLibras') as HTMLElement;
    if (vLibras){
      vLibras.hidden = true;
    }
  }

}
